import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly themeElementId = 'fhco-theme';

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
  }

  loadTenantTheme(): void {
    if (this.document.getElementById(this.themeElementId)) {
      return;
    }

    const themeLink = this.document.createElement('link');
    themeLink.id = this.themeElementId;
    themeLink.rel = 'stylesheet';
    themeLink.href = `${environment.themesAndAssetsUrl}${environment.themeStage}/themes/${environment.themeTenant}/theme.css`;

    this.document.head.appendChild(themeLink);
  }
}
